(function () {
  function qs(s, el) { return (el || document).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

  function toast(msg) {
    var t = qs('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-mobile]')) qs('#MobileNav').classList.add('open');
    if (e.target.closest('[data-close-mobile]') || e.target.id === 'MobileNav') qs('#MobileNav').classList.remove('open');
    if (e.target.closest('[data-toggle-search]')) { var b = qs('#SearchBar'); b.classList.toggle('open'); if (b.classList.contains('open')) qs('input', b).focus(); }
  });

  /* ---------- cart drawer ---------- */
  function openDrawer() { qs('#CartDrawer').classList.add('open'); qs('#DrawerOverlay').classList.add('open'); }
  function closeDrawer() { qs('#CartDrawer').classList.remove('open'); qs('#DrawerOverlay').classList.remove('open'); }
  window.openCartDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); refreshDrawer().then(openDrawer); }
    if (e.target.closest('[data-close-cart]') || e.target.id === 'DrawerOverlay') closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); var m = qs('#MobileNav'); m && m.classList.remove('open'); } });

  function refreshDrawer() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = qs('#CartDrawerContent', tmp);
        var cur = qs('#CartDrawerContent');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var count = qs('#CartCountSrc', tmp);
        if (count) qsa('[data-cart-count]').forEach(function (b) {
          b.textContent = count.textContent;
          b.style.display = count.textContent === '0' ? 'none' : 'grid';
        });
      });
  }

  /* ajax add-to-cart for all product forms */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form.action && form.action.indexOf('/cart/add') > -1)) return;
    e.preventDefault();
    var btn = qs('[type=submit]', form);
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || 'Could not add to cart'); return; }
        refreshDrawer().then(openDrawer);
      })
      .catch(function () { toast('Could not add to cart'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* drawer line qty change / remove */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-line'), 10), quantity: parseInt(b.getAttribute('data-qty'), 10) })
    }).then(function () { refreshDrawer(); });
  });

  /* ---------- product page ---------- */
  var pdata = qs('#ProductJson');
  if (pdata) {
    var product = JSON.parse(pdata.textContent);
    var form = qs('#ProductForm');

    function currentVariant() {
      var opts = qsa('input.opt-radio:checked', form).map(function (i) { return i.value; });
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function money(cents) {
      var m = qs('#MoneyFormat');
      var fmt = m ? m.textContent : '₹{{amount}}';
      return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }
    form && form.addEventListener('change', function (e) {
      if (!e.target.classList.contains('opt-radio')) return;
      var v = currentVariant();
      var idInput = qs('input[name=id]', form);
      var priceEl = qs('#PdPrice'), cmpEl = qs('#PdCompare'), btn = qs('#AddBtn');
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (cmpEl) { if (v.compare_at_price > v.price) { cmpEl.textContent = money(v.compare_at_price); cmpEl.hidden = false; } else cmpEl.hidden = true; }
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
        if (v.featured_image) setMainImage(v.featured_image.src);
        history.replaceState({}, '', window.location.pathname + '?variant=' + v.id);
      } else if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
    });
  }

  function setMainImage(src) {
    var main = qs('#PdMainImg');
    if (main) { main.src = src; main.removeAttribute('srcset'); }
  }
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-thumb]');
    if (!th) return;
    setMainImage(th.getAttribute('data-thumb'));
    qsa('.pd-thumbs button').forEach(function (t) { t.classList.remove('sel'); });
    th.classList.add('sel');
  });

  /* qty box +/- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-delta]');
    if (!b) return;
    var input = qs('input', b.closest('.qty-box'));
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-delta'), 10));
    input.value = v;
  });

  /* auto-submit sort select on collection */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort-select]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.href;
    }
  });
})();
